import FlowsConfigMobileToolbar from '@flows/src/components/flows-configure/FlowsConfigMobileToolbar';
import FLowsConfigToolbarContent from '@flows/src/components/flows-configure/FLowsConfigToolbarContent';
import FlowsConfigureCompanies from '@flows/src/components/flows-configure/FlowsConfigureCompanies';
import FlowsConfigureCoverages from '@flows/src/components/flows-configure/FlowsConfigureCoverages';
import FlowsConfigureFinish from '@flows/src/components/flows-configure/FlowsConfigureFinish';
import FlowsConfigureInsurances from '@flows/src/components/flows-configure/FlowsConfigureInsurances';
import AdvisoryAppShell from '@flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import { useFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/flowsConfigureStore';
import { ErrorBoundary } from '@sentry/react';
import { FC, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router';

export const FLOWS_CONFIG_PATH = '/flow-config';

const FlowsConfigRouter: FC = () => {
  const reset = useFlowsConfigureStore((state) => state.resetStore);

  useEffect(() => {
    reset();
    return () => {
      reset();
    };
  }, []);

  return (
    <ErrorBoundary>
      <AdvisoryAppShell
        toolbarContent={<FLowsConfigToolbarContent />}
        mobileToolbarContent={<FlowsConfigMobileToolbar />}
      >
        <Switch>
          <Redirect
            from={`${FLOWS_CONFIG_PATH}/:flowId`}
            to={{
              pathname: `${FLOWS_CONFIG_PATH}/:flowId/insurances`,
              search: window.location.search,
            }}
            exact
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances`}
            component={FlowsConfigureInsurances}
            exact
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances/:insuranceId/coverages`}
            component={FlowsConfigureCoverages}
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/insurances/:insuranceId/companies`}
            component={FlowsConfigureCompanies}
          />
          <Route
            path={`${FLOWS_CONFIG_PATH}/:flowId/finish`}
            component={FlowsConfigureFinish}
          />
        </Switch>
      </AdvisoryAppShell>
    </ErrorBoundary>
  );
};

export default FlowsConfigRouter;
